import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { RecoilRoot } from "recoil";
import App from "./App";
import CustomThemeProvider from "./theme/Provider";
import { CookiesProvider } from "react-cookie";
import ErrorBoundaryFallback from "./ErrorBoundary";

const rootElement = document.getElementById("root");

// Use createRoot to render your application
const root = createRoot(rootElement);

root.render(
  <RecoilRoot>
    <CookiesProvider>
      <ErrorBoundaryFallback>
        <App />
      </ErrorBoundaryFallback>
    </CookiesProvider>
  </RecoilRoot>
);
